import { createTheme } from '@mui/material/styles';

// Definiere eine konsistente Farbpalette
const palette = {
  primary: {
    main: '#000000', // Schwarz
    light: '#333333',
    dark: '#000000',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#FFFFFF', // Weiß
    light: '#FFFFFF',
    dark: '#CCCCCC',
    contrastText: '#000000',
  },
  error: {
    main: '#FF3B30',
    light: '#FF6B6B',
    dark: '#D50000',
  },
  warning: {
    main: '#FF9500',
    light: '#FFB74D',
    dark: '#F57C00',
  },
  info: {
    main: '#0A84FF',
    light: '#64B5F6',
    dark: '#0952CC',
  },
  success: {
    main: '#30D158',
    light: '#66BB6A',
    dark: '#2E7D32',
  },
  background: {
    default: '#F7F7F7',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#000000',
    secondary: '#8E8E93',
    disabled: '#C7C7CC',
  },
};

// Definiere einheitliche Typografie
const typography = {
  fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  h1: {
    fontWeight: 700,
    fontSize: '2.5rem',
  },
  h2: {
    fontWeight: 700,
    fontSize: '2rem',
  },
  h3: {
    fontWeight: 600,
    fontSize: '1.75rem',
  },
  h4: {
    fontWeight: 600,
    fontSize: '1.5rem',
  },
  h5: {
    fontWeight: 600,
    fontSize: '1.25rem',
  },
  h6: {
    fontWeight: 600,
    fontSize: '1rem',
  },
  body1: {
    fontSize: '1rem',
  },
  body2: {
    fontSize: '0.875rem',
  },
  button: {
    fontWeight: 500,
    textTransform: 'none' as const,
  },
};

// Erstelle das Theme mit den definierten Eigenschaften
const theme = createTheme({
  palette,
  typography,
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          padding: '8px 16px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
          '&:active': {
            boxShadow: 'none',
          },
          '&.MuiButton-primary': {
            backgroundColor: palette.primary.main,
            color: palette.primary.contrastText,
            borderRadius: '8px',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: palette.primary.light,
              boxShadow: 'none',
            },
          },
          '&.MuiButton-secondary': {
            backgroundColor: palette.secondary.main,
            color: palette.secondary.contrastText,
            border: `2px solid ${palette.primary.main}`,
            borderRadius: '8px',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: palette.secondary.dark,
              boxShadow: 'none',
            },
          },
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
          '&:active': {
            boxShadow: 'none',
          },
        },
        outlined: {
          boxShadow: 'none',
        },
        text: {
          boxShadow: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          padding: '16px',
          backgroundColor: palette.background.paper,
          borderRadius: '18px',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
          },
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingTop: '24px',
          paddingBottom: '24px',
        },
      },
    },
  },
});

export default theme;

